module.exports = __webpack_public_path__ + "static/media/error.de9b0304.svg";